var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimmerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Timmer_18px",
    transform: "translate(-531 -5350)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 14,
    height: 14,
    transform: "translate(531 5350)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(532 5351)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#efb926",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M12,8.036V10l2.643,1.462",
    transform: "translate(-6.199 -3.569)",
    fill: "none",
    stroke: "#efb926",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimmerIcon);
export default __webpack_public_path__ + "static/media/timmer-icon.6255faf1b4d1980f4d49a5f0aba85dd9.svg";
export { ForwardRef as ReactComponent };